export const GET_LOGIN_IP_ADDRESS_LIST = "GET_LOGIN_IP_ADDRESS_LIST";
export const GET_REGISTER_IP_ADDRESS_LIST = "GET_REGISTER_IP_ADDRESS_LIST";
export const SHOW_LOGIN_IP_ADDRESS_DETAILS = "SHOW_LOGIN_IP_ADDRESS_DETAILS";
export const SHOW_REGISTER_IP_ADDRESS_DETAILS = "SHOW_REGISTER_IP_ADDRESS_DETAILS";